// JWT 상수 관리
export const INITIAL_JWT = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzZ3RfYWRtaW4iLCJzdWIiOiJjbGllbnQiLCJpYXQiOjE3NzIzMjMwNDgsImV4cCI6MjA4NzY4MzA0OCwic2NvcGUiOlsiVVNFUl9JTkZPIiwiVVNFUl9DUkVERU5USUFMUyIsIk9XQVNQX0FQSSIsIk9QRU5fQVBJIiwiU0NJTSJdfQ._CAeMMzv3toMKSFuUOPsog7J6Orl13R7Oco0WX7NPWA';

// API 엔드포인트
export const API_ENDPOINTS = {
  USER_CREDENTIALS: '/api/v1/user-credentials'
};

// 역할별 사용자 매핑 (동적 JWT 발급을 위한 userId 참조용)
export const ROLES_USER_MAPPING = [
  {
    team: '재무팀',
    position: '팀장',
    userId: 'jfhnodyh@initech.com'
  },
  {
    team: '재무팀',
    position: '팀원',
    userId: 'grvsxwpk@initech.com'
  },
  {
    team: '개발팀',
    position: '팀장',
    userId: 'nefbwqqv@initech.com'
  },
  {
    team: '개발팀',
    position: '팀원',
    userId: 'fcgguamm@initech.com'
  },
  {
    team: '인사팀',
    position: '팀원',
    userId: 'buxmftan@initech.com'
  },
  {
    team: '감사팀',
    position: '팀원',
    userId: 'sxmftan@initech.com'
  }
];